import React, { useEffect, useState } from "react";
import * as image from "../../resources/images";
import Vicky from "../controls/Vicky";
import UserKc from "./UserKc";
import { getSequnceSort } from "../../utils/helper";
import { myJournal } from "../../redux/actions/APIs";
import { useDispatch, useSelector } from "react-redux";
import { SITEURLNAME } from "../../utils/Messages";
const LessonContentRIght = ({ currentSceneObj, handleIsNext, loginType, getMyActivity, getCount, handleTab }) => {
// console.log("currentSceneObj : ", currentSceneObj);

const dispatch = useDispatch();

const {
        my_journal_response,
        loggedInUser
    } = useSelector((state) => state.collections);

const [isJournal, setIsJournal] = useState(false);
const [textAreaContent, setTextAreaContent] = useState("");

const handleJournalChange = (value) => {
    // const getText = value.trimStart();
    if(true){
        setTextAreaContent(value);
        let getTimeoutId = setTimeout(() => {
            saveToJornual(value);
        }, 3000);

        return () => clearTimeout(getTimeoutId);
    }
};

const saveToJornual = (textValue) => {
        const uaId = getMyActivity?.uaId;
        const reqBody = {
            userActivityId: uaId,
            desc: textValue
        };
        
        if (uaId) {
            // console.log('socialActivityDataForMyJournal Step 5 if' , uaId)
            dispatch(myJournal(reqBody));
        } else {
            // console.log('@@@@ Step 5 else')
            console.error('User activity id is not defind');
        }
}

useEffect(()=>{
    let getJournalValue =   my_journal_response?.records[0] ? my_journal_response?.records[0] : getMyActivity?.myjournal; 
    setTextAreaContent(getJournalValue);  
},[my_journal_response, getMyActivity?.myjournal])

return (
    <div className="">
        {loggedInUser?.role?.name === "LEARNER" && currentSceneObj?.kc?.length === 0 && (
            <div className="myjournal_sec">
                {                    
                    <div className="myjournaltoggle pricingcardlist">
                        <h4 className="flexone">Journaling Mode
                            <div class="chooseSubscription ">
                                <div class="form-check form-switch  p-0 ">
                                    <label class="form-check-label d-flex w-90 m-auto p-0 justify-content-end" htmlfor="flexSwitchCheckDefault">
                                        <input class="form-check-input pointer" type="radio" id="planType" checked={isJournal}  onClick={()=>setIsJournal(!isJournal)}/>
                                    </label>
                                </div>
                            </div>
                        </h4>            
                    </div>                    
                }                
        {isJournal && (
                <div className="journaltextbox">
                <h5 className="fw-600">Journal</h5>
                <div className="form-group">
                    <div className="form-group">
                        <textarea 
                            className="form-control"
                            name=""
                            id=""
                            placeholder="Write Down Your Stream Of Thoughts"
                            onChange={(e) => handleJournalChange(e.target.value)}
                            defaultValue={textAreaContent}
                        >
                        </textarea>
                    </div>
                </div>
            </div>
        )}
    </div>
        )}
    
        {!isJournal && currentSceneObj?.kc?.length === 0 ? (
            <div className="">
                <div className="">
                    <div className="realworldapptext">
                        <Vicky text={currentSceneObj?.application} />
                        <p
                            dangerouslySetInnerHTML={{
                                __html: currentSceneObj?.application && currentSceneObj?.application,
                            }}
                        />
                    </div>
                </div>
            </div>
            //   <div className="real_world_app">  
            //   <div className="rwaContentstxt">
            //   <img src={image.wpf_speaker} alt="speaker" className="icon speaker" />
            //              <p className="p2">
            //    Sed ut perspiciatis unde omnis iste natus error sit volup accusantium doloremque laudantium, totam rem ape,
            //    eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim 
            //    ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.
            //    </p>
            //    <ul className="mt-2 mb-2">
            //      <li className="p2 flextwo"><i class="fa-solid fa-star mr-3"></i>Sed ut perspiciatis unde omnis iste natus error sit volup </li>
            //      <li className="p2 flextwo"><i class="fa-solid fa-star mr-3"></i>Sed ut perspiciatis unde omnis iste natus error sit volup </li>
            //      <li className="p2 flextwo"><i class="fa-solid fa-star mr-3"></i>Sed ut perspiciatis unde omnis iste natus error sit volup </li>
            //      <li className="p2 flextwo"><i class="fa-solid fa-star mr-3"></i>Sed ut perspiciatis unde omnis iste natus error sit volup </li>
            //    </ul>
            //    <p className="p2">
            //    Sed ut perspiciatis unde omnis iste natus error sit volup accusantium doloremque laudantium, totam rem ape,
            //     eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.
            //    </p>
            //   </div>

            // </div>
        ) : currentSceneObj?.kc?.length > 0 && (
            <>
                {(!loginType || currentSceneObj?.isCompleted) ? (
                    <UserKc
                        kcData={getSequnceSort(currentSceneObj?.kc)}
                        handleIsNext={handleIsNext}
                        currentSceneObj={currentSceneObj}
                        loginType={loginType}
                        getCount={getCount}
                        handleTab={handleTab}
                    />
                ) : (
                    <div className="locked_Content course_contentblr">
                        <div className="message_box">
                            <p>
                                <i class="fa-solid fa-circle-exclamation"></i>
                            </p>
                            <p className="p1">
                                    
                                Complete the video lesson to unlock {getMyActivity?.series?.scenes?.length === currentSceneObj?.sequence  ? "exercise" : "knowledge check"}!</p>
                        </div>
                        {/* <div className="blurcontent">
                            <img src={image.blurcontent} className="w-100" alt="blurcontent" />
                        </div> */}
                    </div>
                )}
            </>
        )}


    </div>
);
};
export default LessonContentRIght;
